import { SettingsIcon } from "lucide-react";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { usePopper } from "react-popper";

import { IconButton } from "@/components/elements/Button";
import { Menu } from "@headlessui/react";
import { Placement } from "@popperjs/core";

export const TableOptionsMenu = (props: {
  placement?: Placement;
  children: React.ReactNode;
}) => {
  const [referenceElement, setReferenceElement] = useState<any>(null);
  const [popperElement, setPopperElement] = useState<any>(null);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    strategy: "absolute",
    placement: props.placement ?? "auto-start",
    modifiers: [
      { name: "preventOverflow", enabled: false },
      { name: "offset", options: { offset: [5, 10] } },
    ],
  });

  return (
    <Menu>
      <Menu.Button
        as={IconButton}
        size="xs"
        variant="ghost"
        icon={<SettingsIcon className="size-4" />}
        ref={setReferenceElement}
      />
      {createPortal(
        <Menu.Items
          className="z-50 w-56 rounded-md border bg-popover text-popover-foreground shadow-lg ring-1 ring-black/5 focus:outline-hidden"
          style={styles.popper}
          {...attributes.popper}
          ref={setPopperElement}
        >
          {props.children}
        </Menu.Items>,
        document.body,
      )}
    </Menu>
  );
};
